<template>
    <div>
        <!-- slices -->
        <v-dialog v-model="dialog" :max-width="tab > 0 ? 500 : 300" :persistent="submitLoading">
            <v-form ref="form" :disabled="submitLoading" @submit.prevent="submit">
                <v-card>
                    <v-card-title>
                        <span class="me-n6">
							{{!itemId ? $T('add') : $T('edit')}} {{titleDueTab}}
						</span>
						<v-spacer />
						<v-btn icon :disabled="submitLoading" @click="dialog = false">
							<v-icon>$close</v-icon>
						</v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <!-- name -->
                            <v-col :sm="tab > 0 ? 6 : 12" cols="12" class="pa-2">
                                <v-text-field
                                	v-model="dialogData.name"
                                    :label="nameLabel"
                                    dense
                                    outlined
                                    hide-details
                                    :rules="[rules.required]"
                                />
                            </v-col>
                            
                            <!-- slice -->
                            <v-col v-if="tab === 1" sm="6" cols="12" class="pa-2">
                                <v-autocomplete
                                	v-model="dialogData.sliceId"
                                    :label="$T('the-slice')"
                                    :items="slices"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    outlined
                                    hide-details
                                    :rules="[rules.required]"
                                />
                            </v-col>

                            <!-- applying type -->
                            <v-col v-if="[2, 3].includes(tab)" sm="6" cols="12" class="pa-2">
                                <v-autocomplete
                                	v-model="dialogData.applyingType"
                                    :label="$T('inputs.applying-type')"
                                    :items="applyingTypes"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    outlined
                                    hide-details
                                    :rules="[rules.required]"
                                />
                            </v-col>

                            <!-- recompense calculate method -->
                            <v-col v-if="tab === 2" sm="6" cols="12" class="pa-2">
                                <v-autocomplete
                                	v-model="dialogData.recompenseCalculateMethod"
                                    :label="$T('inputs.recompense-calculate-method')"
                                    :items="recompenseCalculateMethods"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    outlined
                                    hide-details
                                    :rules="[rules.required]"
                                />
                            </v-col>
                            
                            <!-- is percent -->
                            <v-col v-if="[2, 3].includes(tab)" sm="6" cols="12" class="pa-2">
                                <v-checkbox
                                	v-model="dialogData.isPercent"
                                    :label="$T('inputs.is-percent')"
                                    dense
                                    hide-details
                                    class="mt-0"
                                    :rules="[rules.required]"
                                />
                            </v-col>
                            
                            <!-- applying type value -->
                            <v-col v-if="[2, 3].includes(tab)" sm="6" cols="12" class="pa-2">
                                <v-text-field
                                	v-model.number="dialogData.applyingTypeValue"
                                    :label="!dialogData.isPercent ? $T('inputs.value') : $T('inputs.percent')"
                                    type="number"
                                    :prefix="dialogData.isPercent ? '%' : null"
                                    hide-spin-buttons
                                    dense
                                    outlined
                                    hide-details
                                    :rules="[!dialogData.isPercent ? rules.requiredAsNumber : rules.isPercent]"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn type="submit" color="success" :loading="submitLoading">{{$T('save')}}</v-btn>
                        <v-btn :disabled="submitLoading" @click="dialog = false">{{$T('close')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        
        <!-- salary equation -->
        <v-dialog v-model="salaryEquationDialog" max-width="500" persistent>
            <v-card>
                <v-card-title>
                    <span class="me-n6">
                        {{!itemId ? $T('add') : $T('edit')}} {{titleDueTab}}
                    </span>
                    <v-spacer />
                    <v-btn icon :disabled="submitEquationLoading" @click="salaryEquationDialog = false">
                        <v-icon>$close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-form
                        ref="submitEquationForm"
                        :disabled="submitEquationLoading"
                        @submit.prevent="submitEquation"
                    >
                        <v-row class="mb-2">
                            <!--  level id -->
                            <v-col sm="6" cols="12" class="pa-2">
                                <v-autocomplete
                                    v-model="salaryEquationDialogData.levelId"
                                    :label="$T('inputs.level')"
                                    :items="levels"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    outlined
                                    hide-details
                                    :rules="[rules.required]"
                                />
                            </v-col>
                            
                            <!-- job description id -->
                            <v-col sm="6" cols="12" class="pa-2">
                                <v-autocomplete
                                    v-model="salaryEquationDialogData.jobDescriptionId"
                                    :label="$T('inputs.employee-position')"
                                    :items="positions"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    outlined
                                    hide-details
                                    :rules="[rules.required]"
                                />
                            </v-col>
                            
                            <!-- salary after installation -->
                            <v-col sm="6" cols="12" class="pa-2">
                                <v-text-field
                                    v-model.number="salaryEquationDialogData.salaryAfterInstallation"
                                    :label="$T('inputs.temporary-appointment-salary')"
                                    type="number"
                                    hide-spin-buttons
                                    dense
                                    outlined
                                    hide-details
                                    :rules="[rules.requiredAsNumber]"
                                />
                            </v-col>
                            
                            <!-- salary on working -->
                            <v-col sm="6" cols="12" class="pa-2">
                                <v-text-field
                                    v-model.number="salaryEquationDialogData.salaryOnWorking"
                                    :label="$T('inputs.permanent-salary')"
                                    type="number"
                                    hide-spin-buttons
                                    dense
                                    outlined
                                    hide-details
                                    :rules="[rules.requiredAsNumber]"
                                />
                            </v-col>
                            
                            <!-- is static -->
                            <v-col sm="6" cols="12" class="pa-2">
                                <v-checkbox
                                    v-model="salaryEquationDialogData.isStatic"
                                    :label="$T('inputs.is-fixed-salary')"
                                    hide-details
                                    class="mt-0"
                                />
                            </v-col>
                        </v-row>
                    </v-form>

                    <!-- recompenses -->
                    <bee-handy-smart-table
                        ref="tableRecompense"
                        v-model="tableInputs.recompense"
                        :headers="recompenseDialogHeaders"
                        :items="salaryEquationDialogData.recompenseEquations"
                        :items-per-page="-1"
                        :show-add-row="!submitEquationLoading"
                        :editable-rows="!submitEquationLoading"
                        dense
                        zebra
                        :data-table-props="{ disableSort: true }"
                        hide-default-footer
                        hide-no-data-area
                        hide-inputs-details
                        table-class="dense-inputs mb-4"
                        @keypress.enter="setEntryRecompense"
                        @change-recompenseId="(val) => {
                            const recompense = getRecompenseById(val);
                            tableInputs.recompense.recompenseIsPercent = recompense.isRate;
                            tableInputs.recompense.recompenseValue = recompense.value;
                        }"
                    >
                        <!-- is percent -->
                        <template v-slot:item.recompenseIsPercent="{ value }">
                            <v-icon v-if="value" size="20">mdi-check-circle-outline</v-icon>
                            <template v-else>-</template>
                        </template>

                        <!-- recompenses -->
                        <template v-slot:input.recompenseId="{ on, attr }">
                            <v-autocomplete
                                v-on="on"
                                v-bind="attr"
                                :items="recompenses"
                                item-text="name"
                                item-value="id"
                                hide-no-data
                            />
                        </template>

                        <!-- is percent -->
                        <template v-slot:input.recompenseIsPercent="{ on, attr }">
                            <v-checkbox
                                :ripple="false"
                                :dense="false"
                                class="mt-0 mx-auto"
                                @change="c => on.input(c)"
                                v-bind="attr"
                            />
                        </template>
                        
                        <!-- value -->
                        <template v-slot:input.recompenseValue="{ on, attr }">
                            <v-text-field
                                type="number"
                                hide-spin-buttons
                                :prefix="tableInputs.recompense.recompenseIsPercent ? '%' : null"
                                :rules="[!tableInputs.recompense.recompenseIsPercent ? rules.required : rules.isPercent]"
                                v-on="on"
                                v-bind="attr"
                            />
                        </template>

                        <!-- actions -->
                        <template v-slot:item.actions="{ index }">
                            <div class="d-flex align-center">
                                <v-btn
                                    icon
                                    color="edit-color"
                                    @click="recompenseIndex = index; $refs.tableRecompense.activeEditForRow(index);"
                                >
                                    <v-icon>$edit</v-icon>
                                </v-btn>
                                <v-btn
                                    icon
                                    color="alert"
                                    @click="() => {
                                        salaryEquationDialogData.recompenseEquations.splice(index, 1);
                                        salaryEquationDialogData.recompenseEquations.forEach((c, i) => {
                                            if (c.id > index) {
                                                salaryEquationDialogData.recompenseEquations[i].id--;
                                            }
                                        })
                                    }"
                                >
                                    <v-icon>$delete</v-icon>
                                </v-btn>
                            </div>
                        </template>
                        
                        <template v-slot:no-input.actions>
                            <v-btn icon color="addRow" @click="setEntryRecompense()">
                                <v-icon>mdi-check-circle-outline</v-icon>
                            </v-btn>
                        </template>
                    </bee-handy-smart-table>

                    <!-- deductions -->
                    <bee-handy-smart-table
                        ref="tableDeduction"
                        v-model="tableInputs.deduction"
                        :headers="deductionDialogHeaders"
                        :items="salaryEquationDialogData.deductionEquations"
                        :items-per-page="-1"
                        :show-add-row="!submitEquationLoading"
                        :editable-rows="!submitEquationLoading"
                        dense
                        zebra
                        :data-table-props="{ disableSort: true }"
                        hide-default-footer
                        hide-no-data-area
                        hide-inputs-details
                        table-class="dense-inputs"
                        @keypress.enter="setEntryDeduction"
                        @change-deductionId="(val) => {
                            const deduction = getDeductionById(val);
                            tableInputs.deduction.deductionIsPercent = deduction.isRate;
                            tableInputs.deduction.deductionValue = deduction.value;
                        }"
                    >
                        <!-- is percent -->
                        <template v-slot:item.deductionIsPercent="{ value }">
                            <v-icon v-if="value" size="20">mdi-check-circle-outline</v-icon>
                            <template v-else>-</template>
                        </template>

                        <!-- deductions -->
                        <template v-slot:input.deductionId="{ on, attr }">
                            <v-autocomplete
                                v-on="on"
                                v-bind="attr"
                                :items="deductions"
                                item-text="name"
                                item-value="id"
                                hide-no-data
                            />
                        </template>

                        <!-- is percent -->
                        <template v-slot:input.deductionIsPercent="{ on, attr }">
                            <v-checkbox
                                :ripple="false"
                                :dense="false"
                                class="mt-0 mx-auto"
                                @change="c => on.input(c)"
                                v-bind="attr"
                            />
                        </template>
                        
                        <!-- value -->
                        <template v-slot:input.deductionValue="{ on, attr }">
                            <v-text-field
                                type="number"
                                hide-spin-buttons
                                :prefix="tableInputs.deduction.deductionIsPercent ? '%' : null"
                                :rules="[!tableInputs.deduction.deductionIsPercent ? rules.required : rules.isPercent]"
                                v-on="on"
                                v-bind="attr"
                            />
                        </template>

                        <!-- actions -->
                        <template v-slot:item.actions="{ index }">
                            <div class="d-flex align-center">
                                <v-btn
                                    icon
                                    color="edit-color"
                                    @click="deductionIndex = index; $refs.tableDeduction.activeEditForRow(index)"
                                >
                                    <v-icon>$edit</v-icon>
                                </v-btn>
                                <v-btn
                                    icon
                                    color="alert"
                                    @click="() => {
                                        salaryEquationDialogData.deductionEquations.splice(index, 1);
                                        salaryEquationDialogData.deductionEquations.forEach((c, i) => {
                                            if (c.id > index) {
                                                salaryEquationDialogData.deductionEquations[i].id--;
                                            }
                                        })
                                    }"
                                >
                                    <v-icon>$delete</v-icon>
                                </v-btn>
                            </div>
                        </template>
                        
                        <template v-slot:no-input.actions>
                            <v-btn icon color="addRow" @click="setEntryDeduction()">
                                <v-icon>mdi-check-circle-outline</v-icon>
                            </v-btn>
                        </template>
                    </bee-handy-smart-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="success" :loading="submitEquationLoading" @click="submitEquation">
                        {{$T('save')}}
                    </v-btn>
                    <v-btn :disabled="submitEquationLoading" @click="salaryEquationDialog = false">
                        {{$T('close')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- tabs -->
        <v-tabs v-model="tab">
            <v-tab>{{$T('tabs.slices')}}</v-tab>
            <v-tab>{{$T('tabs.levels')}}</v-tab>
            <v-tab>{{$T('tabs.recompenses')}}</v-tab>
            <v-tab>{{$T('tabs.deductions')}}</v-tab>
            <v-tab>{{$T('tabs.equations')}}</v-tab>
        </v-tabs>
        <v-divider/>

        <div class="pa-2">
            <!-- add button -->
            <v-row dense class="d-flex justify-end mb-1">
                <v-col cols="auto">
                    <v-btn
                        small
                        color="addRow white--text"
                        @click="tab !== 4 ? dialog = true : salaryEquationDialog = true"
                    >
                        {{$T('add')}} {{titleDueTab}}
                    </v-btn>
                </v-col>
            </v-row>

            <!-- table -->
            <bee-handy-table
                :headers="headers"
                :items="!loading ? items : []"
                dense
                zebra
                :data-table-props="{ disableSort: true }"
                hide-default-footer
                hide-shown-rows-text
            >
                <!-- is percent -->
                <template v-slot:item.isPercent="{ value }">
                    <v-icon v-if="value">mdi-check-circle-outline</v-icon>
                    <span v-else>-</span>
                </template>

                <!-- actions -->
                <template v-slot:item.actions="{ item }">
                    <v-btn
                    	icon
                    	color="edit-color"
                    	@click="itemId = item.id; tab !== 4 ? dialog = true : salaryEquationDialog = true"
                    >
                        <v-icon>$edit</v-icon>
                    </v-btn>
                </template>
            </bee-handy-table>
        </div>
    </div>
</template>

<script>
import rules from '@/utils/validation rules';
import { applyingTypes, recompenseCalculateMethods } from '@/utils/enum';
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'SalariesSettings',

    data() {
        return {
            rules,

            loading: false,
            
            tab: 0,
            
            dialog: false,
            salaryEquationDialog: false,
            
            itemId: null,
            submitLoading: null,
            submitEquationLoading: null,

            applyingTypes,
            recompenseCalculateMethods,

            tableInputs: {
                recompense: {},
                deduction: {},
            },

            recompenseIndex: null,
            deductionIndex: null,
            
            // data
            dialogData: {
                name: null,
                sliceId: null,
                applyingType: null,
                isPercent: false,
                applyingTypeValue: null,
                recompenseCalculateMethod: null
            },
            salaryEquationDialogData: {
                levelId: null,
                jobDescriptionId: null,
                salaryAfterInstallation: null,
                salaryOnWorking: null,
                isStatic: false,
                recompenseEquations: [],
                deductionEquations: []
            },
        }
    },

    watch: {
        dialog(val) {
            if (val) {
                if (this.itemId) {
                    let getter = '';
                    switch (this.tab) {
                        case 0: getter = 'getSliceById'; break;
                        case 1: getter = 'getLevelById'; break;
                        case 2: getter = 'getRecompenseById'; break;
                        case 3: getter = 'getDeductionById'; break;
                    }
                    const item = this[getter](this.itemId);
                    this.dialogData.name = item.name;
                    this.dialogData.sliceId = item.salarySliceId;
                    this.dialogData.applyingType = item.pattern;
                    this.dialogData.isPercent = item.isRate;
                    this.dialogData.applyingTypeValue = item.value;
                    this.dialogData.recompenseCalculateMethod = item.method;
                }
            } else {
                this.dialogData.name = null;
                this.dialogData.sliceId = null;
                this.dialogData.applyingType = null;
                this.dialogData.isPercent = false;
                this.dialogData.applyingTypeValue = null;
                this.dialogData.recompenseCalculateMethod = null;
                this.itemId = null;
                this.$refs.form.resetValidation();
            }
        },

        salaryEquationDialog(val) {
            if (val) {
                if (this.itemId) {
                    const item = this.getSalaryEquationById(this.itemId);
                    this.salaryEquationDialogData.levelId = item.salaryLevelId;
                    this.salaryEquationDialogData.jobDescriptionId = item.jobDescriptionId;
                    this.salaryEquationDialogData.salaryAfterInstallation = item.salaryAfterInstallation;
                    this.salaryEquationDialogData.salaryOnWorking = item.salaryWhenWorking;
                    this.salaryEquationDialogData.isStatic = item.isStatic;
                    
                    this.salaryEquationDialogData.recompenseEquations =
                        item.recompensesEquation.map((c, i) => ({
                            id: i,
                            recompenseId: c.recompenseId,
                            recompenseIsPercent: c.isRate,
                            recompenseValue: c.value
                        }));
                    this.salaryEquationDialogData.deductionEquations =
                        item.deductionsEquation.map((c, i) => ({
                            id: i,
                            deductionId: c.deductionId,
                            deductionIsPercent: c.isRate,
                            deductionValue: c.value,
                        }));
                }
            } else {
                this.$refs.submitEquationForm.reset();
                this.salaryEquationDialogData.recompenseEquations = [];
                this.salaryEquationDialogData.deductionEquations = [];

                if (this.recompenseIndex) {
                    this.recompenseIndex = null;
                    this.$refs.tableRecompense.resetEdit();
                }
                if (this.deductionIndex) {
                    this.deductionIndex = null;
                    this.$refs.tableDeduction.resetEdit();
                }
                this.itemId = null;

                this.$refs.tableRecompense.resetInputs();
                this.$refs.tableDeduction.resetInputs();
            }
        },
    },

    computed: {
        ...mapState({
            slices: state => state.slices.slices,
            levels: state => state.levels.levels,
            recompenses: state => state.recompenses.recompenses,
            deductions: state => state.deductions.deductions,
            salaryEquations: state => state.salaryEquations.salaryEquations,
            positions: state => state.positions.positions,
        }),

        ...mapGetters({
            getSliceById: 'slices/getSliceById',
            getLevelById: 'levels/getLevelById',
            getRecompenseById: 'recompenses/getRecompenseById',
            getDeductionById: 'deductions/getDeductionById',
            getSalaryEquationById: 'salaryEquations/getSalaryEquationById',
            getPositionById: 'positions/getPositionById',
        }),

        // headers
        headers() {
            let headers = [];
            switch(this.tab) {
                case 0:
                case 1: headers = this.slicesLevelsHeaders; break;
                case 2:
                case 3: headers = this.recompensesDeductionsHeaders; break;
                case 4: headers = this.equationsHeaders; break;
            }
            headers =  [
                { text: '#', name: 'no', value: 'no', width: 40, setValueExpr: (val, i) => i + 1 },
                ...headers,
                { text: '', name: 'actions', value: 'actions', width: 40, noNotAvailableText: true }
            ];
            for (let i = 0; i < headers.length; i++) {
                headers[i].columnClass = headers[i].columnClass ? 'px-2' : ' px-2';
            }
            return headers;
        },

        slicesLevelsHeaders() {
            const headers = [
                {
                    text: this.$T('headers.slice'),
                    name: 'name',
                    value: 'name'
                }
            ];
            if (this.tab === 1) {
                headers.push({
                    text: this.$T('headers.slice'),
                    name: 'slice',
                    value: 'salarySliceId',
                    setValueExpr: val => this.getSliceById(val)?.name,
                });
            }
            return headers;
        },
        
        recompensesDeductionsHeaders() {
            const headers = [
                {
                    text: this.tab === 2 ? this.$T('headers.recompense') : this.$T('headers.deduction'),
                    name: 'name',
                    value: 'name'
                },
                {
                    text: this.$T('headers.applying-type'),
                    name: 'applyingType',
                    value: 'pattern',
                    setValueExpr: val => applyingTypes.find(c => c.id === val)?.name ?? '-'
                },
                {
                    text: this.$T('headers.is-percent'),
                    name: 'isPercent',
                    value: 'isRate',
                    width: 90
                },
                {
                    text: this.$T('headers.value'),
                    type: 'number-format',
                    name: 'value',
                    value: 'value',
                    setValueExpr: (val, index) => val + (this.items[index].isRate ? ' %' : '')
                },
            ];
            if (this.tab === 2) {
                headers.push({
                    text: this.$T('headers.recompense-calculate-method'),
                    name: 'recompenseCalculateMethod',
                    value: 'method',
                    noNotAvailableText: true,
                    setValueExpr: val => recompenseCalculateMethods.find(c => c.id === val)?.name ?? '-'
                });
            }
            return headers;
        },
        equationsHeaders() {
            return [
                {
                    text: this.$T('headers.level'),
                    name: 'levelId',
                    value: 'salaryLevelId',
                    setValueExpr: val => this.getLevelById(val)?.name ?? '-',
                },
                {
                    text: this.$T('headers.position-name'),
                    name: 'jobDescriptionId',
                    value: 'jobDescriptionId',
                    setValueExpr: val => this.getPositionById(val)?.name ?? '-',
                },
                {
                    text: this.$T('headers.temporary-appointment-salary'),
                    name: 'afterInstallation',
                    value: 'salaryAfterInstallation',
                    type: 'number-format'
                },
                {
                    text: this.$T('headers.permanent-salary'),
                    name: 'whenWorking',
                    value: 'salaryWhenWorking',
                    type: 'number-format'
                },
                {
                    text: this.$T('headers.is-fixed-salary'),
                    name: 'isStatic',
                    value: 'isStatic'
                },
                {
                    text: this.$T('headers.recompense'),
                    name: 'recompenses',
                    value: 'recompensesEquation',
                    setValueExpr: val => val && val.map(c => this.getRecompenseById(c.recompenseId)?.name).join(', ') || '-'
                },
                {
                    text: this.$T('headers.deduction'),
                    name: 'deductions',
                    value: 'deductionsEquation',
                    setValueExpr: val => val && val.map(c => this.getDeductionById(c.deductionId)?.name).join(', ') || '-'
                },
            ];
        },

        // dialog headers
        recompenseDialogHeaders() {
            const headers = [
                {
                    text: this.$T('headers.recompense'),
                    name: 'recompenseId',
                    value: 'recompenseId',
                    inputRules: [rules.required],
                    setValueExpr: val => this.getRecompenseById(val)?.name ?? '-',
                },
                {
                    text: this.$T('headers.is-percent'),
                    name: 'recompenseIsPercent',
                    value: 'recompenseIsPercent',
                    align: 'center',
                    width: 90
                },
                {
                    text: this.$T('headers.value'),
                    type: 'number-format',
                    name: 'recompenseValue',
                    value: 'recompenseValue',
                    width: 90,
                    setValueExpr: (val, index) =>
                        val + (this.salaryEquationDialogData.recompenseEquations[index].recompenseIsPercent ? ' %' : '')
                },
                { text: '', name: 'actions', value: 'actions', width: 80, noInput: true }
            ];

            for (let i = 0; i < headers.length; i++) {
                headers[i].columnClass = !headers[i].columnClass ? 'px-1' : ' px-1';
            }
            return headers;
        },
        deductionDialogHeaders() {
            const headers = [
                {
                    text: this.$T('headers.deduction'),
                    name: 'deductionId',
                    value: 'deductionId',
                    inputRules: [rules.required],
                    setValueExpr: val => this.getDeductionById(val)?.name ?? '-',
                },
                {
                    text: this.$T('headers.is-percent'),
                    name: 'deductionIsPercent',
                    value: 'deductionIsPercent',
                    align: 'center',
                    width: 90
                },
                {
                    text: this.$T('headers.value'),
                    type: 'number-format',
                    name: 'deductionValue',
                    value: 'deductionValue',
                    width: 90,
                    setValueExpr: (val, index) =>
                        val + (this.salaryEquationDialogData.deductionEquations[index].deductionIsPercent ? ' %' : '')
                },
                { text: '', name: 'actions', value: 'actions', width: 80, noInput: true }
            ];

            for (let i = 0; i < headers.length; i++) {
                headers[i].columnClass = !headers[i].columnClass ? 'px-1' : ' px-1';
            }
            return headers;
        },
        
        // items
        items() {
            let items = [];
            switch(this.tab) {
                case 0: items = this.slices; break;
                case 1: items = this.levels; break;
                case 2: items = this.recompenses; break;
                case 3: items = this.deductions; break;
                case 4: items = this.salaryEquations; break;
            }
            return items;
        },

        // text
        titleDueTab() {
            switch (this.tab) {
                case 0: return this.$T('slice');
                case 1: return this.$T('level');
                case 2: return this.$T('recompense');
                case 3: return this.$T('deduction');
                case 4: return this.$T('equation');
            }
            return '';
        },
        nameLabel() {
            switch (this.tab) {
                case 0: return this.$T('inputs.slice-name');
                case 1: return this.$T('inputs.level-name');
                case 2: return this.$T('inputs.recompense-name');
                case 3: return this.$T('inputs.deduction-name');
                case 4: return this.$T('inputs.equation-name');
            }
            return '';
        },
    },

    methods: {
        fetchData() {
            this.loading = true;
            let moduleName;
            switch (this.tab) {
            case 0: moduleName = 'slices'; break;
            case 1: moduleName = 'levels'; break;
            case 2: moduleName = 'recompenses'; break;
            case 3: moduleName = 'deductions'; break;
            case 4: moduleName = 'salaryEquations'; break;
            }
            return this.$store.dispatch(`${moduleName}/fetchAll`).finally(() => {
                this.loading = false;
            })
        },

        fetchSalaryEquations() {
            
        },

        // tables functions
        setEntryRecompense() {
            if (!this.$refs.tableRecompense.validate()) return;
            if (this.recompenseIndex !== null) {
                this.salaryEquationDialogData.recompenseEquations[this.recompenseIndex].recompenseId =
                    this.tableInputs.recompense.recompenseId;
                this.salaryEquationDialogData.recompenseEquations[this.recompenseIndex].recompenseIsPercent =
                    this.tableInputs.recompense.recompenseIsPercent;
                this.salaryEquationDialogData.recompenseEquations[this.recompenseIndex].recompenseValue = 
                    this.tableInputs.recompense.recompenseValue;
                
                this.$refs.tableRecompense.resetEdit();
                this.recompenseIndex = null;
            } else {
                this.salaryEquationDialogData.recompenseEquations.push({
                    id: this.salaryEquationDialogData.recompenseEquations.length,
                    ...this.tableInputs.recompense
                });
            }
            this.$refs.tableRecompense.resetInputs();
            this.$nextTick(() => {
                this.$refs.tableRecompense.resetInputsFocus();
            })
        },
        setEntryDeduction() {
            if (!this.$refs.tableDeduction.validate()) return;
            if (this.deductionIndex !== null) {
                this.salaryEquationDialogData.deductionEquations[this.deductionIndex].deductionId =
                    this.tableInputs.deduction.deductionId;
                this.salaryEquationDialogData.deductionEquations[this.deductionIndex].deductionIsPercent =
                    this.tableInputs.deduction.deductionIsPercent;
                this.salaryEquationDialogData.deductionEquations[this.deductionIndex].deductionValue =
                    this.tableInputs.deduction.deductionValue;

                this.$refs.tableDeduction.resetEdit();
                this.deductionIndex = null;
            } else {
                this.salaryEquationDialogData.deductionEquations.push({
                    id: this.salaryEquationDialogData.deductionEquations.length,
                    ...this.tableInputs.deduction
                });
            }
            this.$refs.tableDeduction.resetInputs();
            this.$nextTick(() => {
                this.$refs.tableDeduction.resetInputsFocus();
            })
        },

        submit() {
            if (this.$refs.form.validate()) {
                let moduleName;
                switch (this.tab) {
                case 0: moduleName = 'slices'; break;
                case 1: moduleName = 'levels'; break;
                case 2: moduleName = 'recompenses'; break;
                case 3: moduleName = 'deductions'; break;
                }
                const action = this.itemId ? 'update' : 'create';
                
                this.submitLoading = true;
                this.$store.dispatch(`${moduleName}/${action}`, {
                    id: this.itemId,
                    name: this.dialogData.name,
                    sliceId: this.dialogData.sliceId,
                    pattern: this.dialogData.applyingType,
                    isRate: this.dialogData.isPercent,
                    value: this.dialogData.applyingTypeValue,
                    method: this.dialogData.recompenseCalculateMethod,
                }).then(() => {
					this.fetchData();
					this.$eventBus.$emit(
						'show-snackbar',
						!this.itemId ? this.$T('messages.add-done') : this.$T('messages.edit-done'),
						{ done: true }
					);
					this.dialog = false;
				}).catch((err) => {
					err.default && err.default(
						!this.itemId ? this.$T('messages.add-fail') : this.$T('messages.edit-fail'),
						true
					);
				}).finally(() => {
					this.submitLoading = false;
				})
            }
        },

        submitEquation() {
            if (this.$refs.submitEquationForm.validate()) {
                this.submitEquationLoading = true;
                const action = this.itemId ? 'update' : 'create';
                this.$store.dispatch(`salaryEquations/${action}`, {
                    id: this.itemId,
                    jobDescriptionId: this.salaryEquationDialogData.jobDescriptionId,
                    salaryLevelId: this.salaryEquationDialogData.levelId,
                    salaryAfterInstallation: this.salaryEquationDialogData.salaryAfterInstallation,
                    salaryWhenWorking: this.salaryEquationDialogData.salaryOnWorking,
                    isStatic: this.salaryEquationDialogData.isStatic,
                    recompenseEquations: this.salaryEquationDialogData.recompenseEquations.map(c => ({
                        recompenseId: c.recompenseId,
                        isRate: c.recompenseIsPercent,
                        value: c.recompenseValue,
                    })),
                    deductionEquations: this.salaryEquationDialogData.deductionEquations.map(c => ({
                        deductionId: c.deductionId,
                        isRate: c.deductionIsPercent,
                        value: +c.deductionValue,
                    }))
                }).then(() => {
					this.fetchData();
					this.$eventBus.$emit(
						'show-snackbar',
						!this.itemId ? this.$T('messages.add-done') : this.$T('messages.edit-done'),
						{ done: true }
					);
					this.salaryEquationDialog = false;
				}).catch((err) => {
					err.default && err.default(
						!this.itemId ? this.$T('messages.add-fail') : this.$T('messages.edit-fail'),
						true
					);
				}).finally(() => {
					this.submitEquationLoading = false;
				})
            }
        }
    },

    created() {
        this.loading = true;
        Promise.all([
            !this.slices.length ? this.$store.dispatch('slices/fetchAll') : null,
            !this.levels.length ? this.$store.dispatch('levels/fetchAll') : null,
            !this.deductions.length ? this.$store.dispatch('deductions/fetchAll') : null,
            !this.recompenses.length ? this.$store.dispatch('recompenses/fetchAll') : null,
            !this.salaryEquations.length ? this.$store.dispatch('salaryEquations/fetchAll') : null,
        ]).finally(() => {
            this.loading = false;
        });
    }
}
</script>

<style>

</style>